import { useI18nContext } from "@hopper-b2b/i18n";
import { CarSortOptionEnum } from "@apac/components/cars";

export interface CarListSortOptions {
  // A unique identifier for the sort option
  value: CarSortOptionEnum;
  // A user-facing string that describes this sort option
  label: string;
  // A shorter user-facing string used when the option is selected
  shortLabel: string;
}

export const useCarListSortOptions = (): CarListSortOptions[] => {
  const { t } = useI18nContext();
  return [
    {
      value: CarSortOptionEnum.Recommended,
      label: t("apac.cars.sort.options.recommended"),
      shortLabel: t("apac.cars.sort.options.recommendedShortened"),
    },
    {
      value: CarSortOptionEnum.Price,
      label: t("apac.cars.sort.options.price"),
      shortLabel: t("apac.cars.sort.options.priceShortened"),
    },
    {
      value: CarSortOptionEnum.Distance,
      label: t("apac.cars.sort.options.distance"),
      shortLabel: t("apac.cars.sort.options.distanceShortened"),
    },
  ];
};
